import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/img/circle-example.png'
import _imports_1 from '../../../assets/img/circle.png'
import _imports_2 from '../../../assets/img/site.png'


const _hoisted_1 = { class: "apply-wrapper" }

import { onMounted, onUnmounted, ref } from "vue";
import { useRoute } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'applyExample',
  setup(__props) {

const route = useRoute();

onMounted(() => {
  // console.log("mounted");
});

onUnmounted(() => {
  // console.log("unmounted");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<div class=\"apply-title\" data-v-e725808a>应用场景案例</div><div class=\"example-wrapper\" data-v-e725808a><div class=\"example-item\" data-v-e725808a><div class=\"title\" data-v-e725808a>圈选三方保养用户</div><div class=\"desc\" data-v-e725808a> 基于工单数据、车辆数据（复位信号数据、GPS数据），通过人群识别模型计算计算出在外保养的用户人群 </div><div class=\"circle-example\" data-v-e725808a><img src=\"" + _imports_0 + "\" data-v-e725808a></div><div class=\"example-img\" data-v-e725808a><img src=\"" + _imports_1 + "\" data-v-e725808a></div></div><div class=\"example-item example-item-site\" data-v-e725808a><div class=\"title\" data-v-e725808a>推荐服务站</div><div class=\"desc\" data-v-e725808a> 计算车辆常住地城市，根据车辆高频/低频点推荐附近的服务站门店 </div><div class=\"example-img\" data-v-e725808a><img src=\"" + _imports_2 + "\" data-v-e725808a></div></div></div>", 2)
  ])))
}
}

})